import { LinkItem } from "Interfaces/general.interface";

import TabsItem from './TabsItem';
import TabsSwiperContainer from './TabsSwiperContainer';
import ComponentHeader from "GeneralComponents/ComponentHeader";
import CustomLinkButton from 'GeneralComponents/CustomLinkButton';
import CarouselItem from 'MiniSiteComponents/Carousel/Carousel.interface';

interface Props {
    dir: string;
    componentId: string;
    items: CarouselItem[]
    componentTitle: string;
    isSwiperInit: boolean;
    itemstoshow: number;
    lightBg: boolean;
    link: LinkItem;
    componentDescription: string;
    isLaptop: boolean;
}


const TabsCarousel: React.FC<Props> = (props) => {

    const { dir, componentId, items, componentTitle, lightBg, link, isLaptop, componentDescription } = props;
    const MAX_ITEMS_WITHOUT_CAROUSEL = 5;
    const displayTabsWithoutCarousel = ((items.length <= MAX_ITEMS_WITHOUT_CAROUSEL && isLaptop) || items.length === 1);

    return <div className="mst-carousel">

        <article className="px-0 mst-carousel-tabs">

            <div className="container" >

                <ComponentHeader
                    disptitle={componentTitle}
                    dispdescription={componentDescription}
                    light={lightBg}
                    shortMargin={link.url ? true : false}
                />
                {
                    link && link.url &&
                    < CustomLinkButton
                        pageUrl={""}
                        link={link}
                        isBtn={false}
                        btnClass={""}
                        linkClass={"tab-link-btn" + (items.length > MAX_ITEMS_WITHOUT_CAROUSEL ? " tab-link-btn-margin" : "")}
                        dir={dir}
                        linkIcon={true}
                        charLimit={25}
                    />
                }
            </div>
            {
                displayTabsWithoutCarousel ?

                    <TabsItem
                        dir={dir}
                        items={items.slice(0, MAX_ITEMS_WITHOUT_CAROUSEL)}
                        componentTitle={componentTitle}
                        componentId={"Carousel-" + componentId}
                    />
                    :

                    <TabsSwiperContainer {...props} />

            }
            {link && link.url &&
                <div className="bg-pallete-color pb-3">

                    <CustomLinkButton
                        pageUrl={""}
                        link={link}
                        isBtn={false}
                        btnClass={""}
                        linkClass={"btn btn-outline-primary mst-btn tab-link-btn-mobile"}
                        dir={dir}
                        linkIcon={true}
                        charLimit={25}
                    />

                </div>
            }

        </article>

    </div>
}

export default TabsCarousel;